import { RenterProfileStandalonePageCreditScore } from '@zg-rentals/ts-renter-info-client';

// Value/label maps for the renter profile enums, shared by the profile form
// (RenterProfileFormFields) and the read-only profile view (ViewRenterProfileContent).

export type RadioOption = {
  value: string;
  label: string;
};

export type CreditScoreChipOption = {
  label: string;
  value: RenterProfileStandalonePageCreditScore;
};

export const LEASE_DURATION_OPTIONS: Array<RadioOption> = [
  { value: 'MONTH_TO_MONTH', label: 'Month-to-month' },
  { value: '6_MONTHS', label: '6 months' },
  { value: '12_MONTHS', label: '12 months' },
  { value: '13_PLUS_MONTHS', label: '13+ months' },
];

export const NUM_BEDROOMS_OPTIONS: Array<RadioOption> = [
  { value: 'STUDIO', label: 'Studio' },
  { value: '1_BD', label: '1' },
  { value: '2_BDS', label: '2' },
  { value: '3_BDS', label: '3' },
  { value: '4_PLUS_BDS', label: '4+' },
];

export const NUM_HOUSEHOLD_OPTIONS: Array<RadioOption> = [
  { value: '1', label: '1' },
  { value: '2', label: '2' },
  { value: '3', label: '3' },
  { value: '4', label: '4' },
  { value: '5_PLUS', label: '5+' },
];

export const PET_OPTIONS: Array<RadioOption> = [
  { value: 'YES', label: 'Yes' },
  { value: 'NO', label: 'No' },
];

export const PARKING_OPTIONS: Array<RadioOption> = [
  { value: 'YES', label: 'Yes' },
  { value: 'NO', label: 'No' },
];

export const CREDIT_SCORE_CHIP_OPTIONS: Array<CreditScoreChipOption> = [
  { label: '300-579', value: RenterProfileStandalonePageCreditScore.RANGE_300_579 },
  { label: '580-619', value: RenterProfileStandalonePageCreditScore.RANGE_580_619 },
  { label: '620-659', value: RenterProfileStandalonePageCreditScore.RANGE_620_659 },
  { label: '660-719', value: RenterProfileStandalonePageCreditScore.RANGE_660_719 },
  { label: '720+', value: RenterProfileStandalonePageCreditScore.RANGE_720_PLUS },
];
